import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Textarea from 'react-textarea-autosize'

class Input extends Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      originalClassName: this.props.className,
      className: this.props.className,
      filled: false
    }
  }

  componentDidMount() {
    const {defaultValue} = this.props
    // console.log('defaultValue', defaultValue)

    if (defaultValue) {
      this.setState({
        className: this.state.originalClassName + ' filled'
      })
    }
  }

  handleChange = async (event) => {
    console.log('Input - handleChange() - event.target.value', event.target.value)
    const filled = event.target.value.length > 0
    // old new changed - it is XOR ^
    //  0   0     0
    //  0   1     1
    //  1   0     1
    //  1   1     0
    if (filled ^ this.state.filled) {
      this.setState({
        filled,
        className: filled
          ? this.state.originalClassName + ' filled'
          : this.state.originalClassName
      })
    }
    // Call function that was set in the parent
    const {onChange} = this.props
    if (onChange) {
      onChange(event)
    }
  }

  render () {
    const {element_type} = this.props

    if (element_type === 'textarea') {
      return (
        <Textarea {...this.props}
                  minRows={3}
                  maxRows={6}
                  className={this.state.className}
                  onChange={this.handleChange} />
      )
    }

    return (
      <input {...this.props}
             className={this.state.className}
             onChange={this.handleChange} />
    )
  }
}

Input.defaultProps = {
  element_type: 'input'
}

Input.propTypes = {
  element_type: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func
}

export default Input



// WEBPACK FOOTER //
// ./src/components/Input.js